import { createAppSelector, recordingSessionSelectors } from "./base";

import { RecordingSessionState } from "components/server-types";

export const selectRecordingSessionsByClassSessionId = createAppSelector(
  [recordingSessionSelectors.selectAll, (state, classSessionId: string) => classSessionId],
  (recordingSessions, classSessionId) =>
    recordingSessions.filter((rs) => rs.class_session_id === classSessionId),
);

export const selectActiveRecordingSessionForCurrentSection = createAppSelector(
  [recordingSessionSelectors.filterForCurrentSection],
  (recordingSessions) =>
    recordingSessions.find((rs) =>
      [
        RecordingSessionState.PREPARING,
        RecordingSessionState.STARTING,
        RecordingSessionState.STARTED,
      ].includes(rs.state),
    ),
);
